import { getSubscriptionOptions, type UserSubscription } from '@platform/api';
import type { QueryClient } from '@tanstack/react-query';
import { SILENT_ERROR_META } from '../queryMeta';

/**
 * Fails open to `undefined`: every caller only uses the subscription to decide UI/routing, so an
 * outage or schema drift should let the visit through rather than block it. Shared so the fail-open
 * `ensureQueryData` wrapping lives in one place instead of once per caller.
 */
export async function readSubscription(queryClient: QueryClient): Promise<UserSubscription | undefined> {
  try {
    return await queryClient.ensureQueryData({ ...getSubscriptionOptions(), meta: SILENT_ERROR_META });
  } catch {
    return undefined;
  }
}

/** Whether the visitor's active subscription is free — `undefined` when it fails open, same as {@link readSubscription}. */
export async function readIsInFreeSubscription(queryClient: QueryClient): Promise<boolean | undefined> {
  const subscription = await readSubscription(queryClient);
  return subscription?.flags?.isInFreeSubscription;
}
